<template>
  <v-app style="overflow-x:hidden;">
    <v-main v-if="!loggedIn()">
      <router-view />
    </v-main>
    <v-main id="main" class="pt-4" v-if="loggedIn()">
      <v-container>
        <v-navigation-drawer
          v-model="drawer"
          app
          class="sidebar sidebar-shadow"
          style="z-index: 9999;"
        >
          <v-row justify="center" class="mt-5 mb-5">
            <a :href="this.$config.site_redirect_url" target="blank">
              <img
                :src="this.getImgUrl1(this.$config.icon_above_side_menu)"
                width="200"
                style="padding-top:20px; padding-bottom: 10px;"
              />
            </a>
          </v-row>

          <v-row justify="center" class="mt-1 mb-5">
            <strong class="avtar-title">
              <v-avatar class="avtar-title" color="primary" size="30">
                <v-icon size="20" color="white">mdi-account</v-icon>
              </v-avatar>
              {{ getUserName() }}</strong
            >
          </v-row>

          <div>
            <v-list
              v-for="each in this.sideOptions"
              :key="each.display_name"
              dense
            >
              <router-link :to="each.route_path" v-if="!each.submenu">
                <v-list-item @click="clearcrumbsdict()">
                  <v-list-item-action>
                    <v-icon>mdi-chart-areaspline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ each.display_name }}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </router-link>

              <v-list-group
                prepend-icon="mdi-account"
                no-action
                v-if="each.submenu"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      each.display_name
                    }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <div v-for="eac in each.submenu" :key="eac.display_name">
                  <router-link :to="eac.route_path">
                    <v-list-item @click="clearcrumbsdict()">
                      <v-list-item-action>
                        <v-icon>icon-speed-disable</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          eac.display_name
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </router-link>
                </div>
              </v-list-group>
            </v-list>
          </div>
        </v-navigation-drawer>

        <v-app-bar
          app
          flat
          color="#ffffff"
          style="z-index: 99999; height:fit-content "
        >
          <v-app-bar-nav-icon color="#004080" @click="drawer = !drawer"></v-app-bar-nav-icon>

          <div
            style="display: flex; justify-content: space-between; width: 100%;"
          >
            <span
              class="text-blue text-capitalize"
              style="font-weight: bold; font-size: larger;"
            >
              {{ pageTitle }}
            </span>

            <div style="display: flex; align-items: center;">
              <v-icon v-if="value_super" color="primary" @click="callGetOption"
                >mdi-home</v-icon
              >

              <button
                class=" ml-4 "
                v-on:click="this.logUserOut"
                color="#FE000C"
                small
              >
                <div>
                  <v-icon color="#FE000C" size="25" style="stroke-width: 20;">
                    mdi-logout
                  </v-icon>
                  <span
                    style="color: #FE000C; font-weight: bold;"
                    id="logout-nav-bar"
                    >Logout</span
                  >
                </div>
              </button>
            </div>
          </div>
        </v-app-bar>
      </v-container>

      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import router from "./router";
import axios from "axios";

export default {
  name: "App",

  components: {},

  data: () => ({
    customerItems: [],
    value_super: true,
    customerSelected: null,
    show: true,
    superuser: false,
    drawer: null,
    sideOptions: [],
    scroll: false,
    switch1: false,
    mad: "mdi-chart-areaspline",

    user: {
      avatar: require("@/assets/user-profile.png"),
      name: "John Leider",
    },
  }),
  mounted() {
    console.log("App.vue mounted");
    // window.addEventListener('beforeunload', this.handleTabClose);
  },
  methods: {
    handleTabClose(event) {
      // Your logic for handling the tab close event
      // For example, you can show a confirmation dialog
      const confirmationMessage = "Are you sure you want to leave?";

      this.logUserOut(); // Display an alert when the tab is about to be closed
      // alert(confirmationMessage);

      // Standard for most browsers
      event.returnValue = confirmationMessage;

      // For some older browsers
      return confirmationMessage;
    },
    callGetOption() {
      this.clearcrumbsdict();
      sessionStorage.removeItem("route_first_option");

      console.log(
        "checking session object",
        typeof sessionStorage.getItem("super_to_user_org_id"),
        sessionStorage.getItem("super_to_user_org_id"),
        "also"
      );

      this.getOptions("super");
    },
    getCustomer() {
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getCustomerNamesforSuperUser`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          console.log("checking customer_name", response.data.data);
          this.customerItems = response.data.data;
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            // Handle error
          }
        });
    },
    change_value() {
      console.log("checking value", this.switch1);
      this.$root.$emit("value_of_checkbox", this.switch1);
    },
    getUserName() {
      let storage = sessionStorage.getItem("userName");
      // let self = this;
      let customersData = sessionStorage.getItem("customers_data");
      console.log("checking customer data", customersData);
      if (storage) {
        console.log("checking username");

        console.log("username is here", storage, this.show);

        if (!this.optionsReceived) {
          console.log("Cehciing before done");
          this.getOptions();
        }
        return storage;
      } else {
        return null;
      }
    },
    getOrganizationName() {
      if (
        sessionStorage.getItem("organizationName").toUpperCase() ===
        "SUNDARAM AUTO COMPONENTS LTD"
      ) {
        return "SACL";
      }
      console.log(
        "Checking organization",
        sessionStorage.getItem("organizationName").toUpperCase()
      );
      return sessionStorage.getItem("organizationName").toUpperCase();
    },
    loggedIn() {
      let storage = sessionStorage.getItem("jwt");
      console.log("checking storage after loggedin", storage);
      console.log(
        "checking session obj before getop",
        sessionStorage.getItem("super_to_user_org_id"),
        typeof sessionStorage.getItem("super_to_user_org_id")
      );
      if (storage) {
        console.log("checki ng how many returns", this.$route.name);
        if (this.$route.name != "/superUserPage") {
          this.value_super = true;
        } else {
          router.push("/");
          this.value_super = false;
        }
        return true;
      } else {
        return false;
      }
    },
    async logUserOut() {
      console.log(
        "logging out",
        sessionStorage,
        this.uniqueDataList,
        sessionStorage.getItem("storedUniqueList")
      );

      this.optionsReceived = false;
      let params = ``;
      console.log("params", params);

      let config = {
        method: "post",
        url: `${this.$config.backend_url}/logout${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          logout: sessionStorage.getItem("logintime"),
        },
      };
      await axios(config).then((response) => {
        console.log("logging out --->>>", response);
      });
      sessionStorage.clear();

      router.push("/login");
    },

    getOptions(event) {
      console.log("checking if id is there or nit", event);
      console.log("checking options", sessionStorage.getItem("token"));

      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getConfiguredCustomerFeatures`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      if (event != undefined) {
        config = {
          method: "get",
          url: `${this.$config.backend_url}/getConfiguredCustomerFeatures?event=${event}`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
      }
      if (event == "super") {
        config = {
          method: "get",
          url: `${this.$config.backend_url}/getConfiguredCustomerFeatures?event=super`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
      }

      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          console.log(response.data.data);
          this.sideOptions = response.data.data[0];
          this.customerItems = response.data.data[1] || [];
          console.log(
            "checking when it for routepath and routefirstpath  ",
            sessionStorage.getItem("route_first_option")
          );
          console.log(
            "checking when it ",
            this.customerItems,
            response.data.session_token
          );
          if (response.data.session_token != null) {
            console.log("checking whether is sucess");
            // sessionStorage.removeItem("token");
            // sessionStorage.setItem("token", response.data.session_token);
          }
          console.log(
            "checking toekn value in session",
            sessionStorage.getItem("token"),
            typeof sessionStorage.getItem("token")
          );

          if (this.customerItems.length != 0) {
            this.superuser = true;
          } else {
            this.superuser = false;
          }

          this.optionsReceived = true;
          console.log(
            " checking value",
            sessionStorage.getItem("route_first_option"),
            typeof sessionStorage.getItem("route_first_option")
          );
          // sujan (added condition for routing to energy monitoring and OEE monitoring dashboards from super DPM page.)
          if (
            sessionStorage.getItem("route_first_option") != null &&
            (sessionStorage.getItem("route_first_option") ==
              "/EnergyMonitoring" ||
              sessionStorage.getItem("route_first_option") == "/multipleOEE")
          ) {
            router.push(sessionStorage.getItem("route_first_option"));
          } else {
            sessionStorage.removeItem("route_first_option");
            sessionStorage.setItem("route_first_option", "/");
            router.push("/");
            sessionStorage.setItem(
              "route_first_option",
              this.sideOptions[0].route_path
            );

            router.push(this.sideOptions[0].route_path);
          }

          console.log("checki ng route ", this.$route.name);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            // Handle error
          }
        });
      console.log("checking this.sideOptions before pushing", this.sideOptions);
      if (this.sideOptions.length != 0) {
        router.push(this.sideOptions[0].route_path);
      } else {
        console.log(
          "there is no navigation options so rerendering and checking to get them"
        );
      }
    },
  },

  beforeMounted() {},
  computed: {
    pageTitle: function() {
      console.log("checking things");
      if (sessionStorage.getItem("super_to_user_org_id") != null) {
        this.getOptions(sessionStorage.getItem("super_to_user_org_id"));
        sessionStorage.removeItem("super_to_user_org_id");
      }

      return this.$route.meta.title;
    },
  },
};
</script>
<style>
@import "./assets/fonts/style.css";
@import "./assets/custome.css";

@media screen and (max-width: 600px) {
  #logout-nav-bar {
    display: none;
  }
}
</style>
